import { render, staticRenderFns } from "./addAreaNews.vue?vue&type=template&id=22ca3a69&scoped=true"
import script from "./addAreaNews.vue?vue&type=script&lang=js"
export * from "./addAreaNews.vue?vue&type=script&lang=js"
import style0 from "./addAreaNews.vue?vue&type=style&index=0&id=22ca3a69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca3a69",
  null
  
)

export default component.exports